import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['select']

  connect() {
    let unsaved = false

    $(document).on('click.check-unsaved', '.delete-procedure', function() {
      return unsaved = true
    })

    $(document).on('change.check-unsaved', 'input', function () {
      return unsaved = true
    })

    $(document).on('turbolinks:before-visit.check-unsaved', (event) => {
      if (unsaved && !this.isConfirmed()) {
        event.preventDefault()

        swal({
          title: 'Você fez modificações e não salvou. Tem certeza que quer continuar?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.data.set('isConfirmed', true)
          Turbolinks.visit(event.originalEvent.data.url)
        } else {
          if (this.hasSelectTarget) {
            let value = (window.location.href.split('category=')[1] || 'others').split('&')[0]
            $(this.selectTarget).find('option[value=' + value + ']').prop('selected', true)
          }
        }
      })
      }
    })

    $(document).on('turbolinks:load.check-unsaved', function () {
      return unsaved = false
    })
  }

  isConfirmed() {
    return this.data.get('isConfirmed') == 'true'
  }

  disconnect() {
    // set isConfirmed to false otherways if going back to cache isConfirmed is
    // set to true and wont appear the alert
    this.data.set('isConfirmed', false)
    $(document).off('change.check-unsaved', 'input')
    $(document).off('turbolinks:before-visit.check-unsaved')
    $(document).off('turbolinks:load.check-unsaved')
    $(document).off('click.check-unsaved')
  }
}
